export const isWebRTCSupported =
  !!navigator.mediaDevices.enumerateDevices &&
  !!navigator.mediaDevices.getUserMedia;
